import axios from '@utils/axiosInstance'
import { v4 as uuidv4 } from 'uuid'
import { ActorDto } from '@state/infrastructure/actor/dto/ActorDto'

const BASE = process.env.VUE_APP_BACKEND_PUBLIC_URL

const getDefaultState = () => {
  return {
    invitationList: [],
    invitation: null,
  }
}
export const state = getDefaultState()

export const getters = {}

export const mutations = {
  UPDATE_INVITATIONS(state, invitations) {
    state.invitationList = invitations
  },
  UPDATE_INVITATION(state, invitation) {
    state.invitation = invitation
  },
}

export const actions = {
  async fetchInvitations(store, payload) {
    let queryString = `?sort=dateSent`
    if (payload.key) {
      queryString = encodeURI(
        queryString + `&filter[${payload.key}]=${payload.value}`,
      )
    }

    const url = `${BASE}/mx/api/v2/${payload.personnelDivision}/invitations${queryString}`
    try {
      const response = await axios.get(url)
      store.commit('UPDATE_INVITATIONS', response.data)
    } catch (error) {
      throw new Error(
        `API Error occurred at API Error occurred at api/invitations.`,
      )
    }
  },

  async fetchInvitation(store, payload) {
    const url = `${BASE}/mx/api/v2/${payload.personnelDivision}/invitation/${payload.rfc}`
    try {
      const response = await axios.get(url)
      store.commit('UPDATE_INVITATION', response.data)
    } catch (error) {
      throw new Error(
        `API Error occurred at API Error occurred at api/invitation.`,
      )
    }
  },

  async deleteInvitation(store, data) {
    const uuid = uuidv4()
    const actorDto = new ActorDto(null, data.userId, null)

    const payload = {
      uuid,
      actorDto,
      rfc: data.rfc,
    }

    return await axios.post(
      `${BASE}/mx/api/v2/${data.personnelDivision}/invitation/delete`,
      payload,
    )
  },

  async commitInvitation({ commit }, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/createInvitation`, payload)
    } catch (e) {
      throw Error('API Error occurred in api/createInvitation.')
    }
  },
}
